import { computed, useId } from 'vue'

export function useInputHandlers(properties, emit) {
  // Compute inputId or fallback to generated ID
  const inputId = computed(() => properties.id || useId())

  // Two-way binding for input value
  const inputValue = computed({
    get: () => properties.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })

  // Emit the model update and input event
  function handleInput(event) {
    const value = 'value' in event ? event.value : event.target.value
    inputValue.value = value
    emit('update:modelValue', value)
    emit('input', inputValue.value)
  }

  // Handle focus event
  function handleFocus(event) {
    emit('focus', event)
  }

  // Handle blur event
  function handleBlur() {
    emit('blur', inputValue.value)
  }

  function handleEnter() {
    emit('enter', inputValue.value)
  }

  // Return all methods and computed properties for reuse
  return {
    inputId,
    inputValue,
    handleInput,
    handleFocus,
    handleBlur,
    handleEnter,
  }
}
